import React, { useEffect } from 'react';
import ReplayIcon from '@mui/icons-material/Replay';

import { addGeneralLogEntry } from 'flow/utils/browser-utils';
import IconButton from 'flow/components/ui-components/IconButton';

interface Props {
    onClick: () => void;
}
const ErrorBoundaryView = ({ onClick }: Props) => {
    useEffect(() => {
        addGeneralLogEntry('Error view mounted');
        return () => {
            addGeneralLogEntry('Error view unmounted');
        };
    }, []);

    return (
        <div className="flex size-full flex-col items-center justify-center text-2xl">
            <div>{'😢'}</div>
            <div>{'Something went wrong...'}</div>

            <IconButton onClick={onClick}>
                <ReplayIcon />
            </IconButton>
        </div>
    );
};

export default ErrorBoundaryView;
